<template>
  <div>
    <div>
      <v-app-bar flat color="white" class="x-scroll">
        <div class="pa-2">
          <v-btn class="info font-weight-bold" @click="onNew"
            ><v-icon left>mdi-plus-box</v-icon
            ><span class="d-none d-sm-flex">新規登録</span
            ><span class="d-sm-none">新規</span></v-btn
          >
        </div>
        <div class="pa-2">
          <v-btn class="info font-weight-bold" @click="onUpdateButton"
            ><v-icon left>mdi-sync</v-icon
            ><span class="d-none d-sm-flex">一括更新</span
            ><span class="d-sm-none">更新</span></v-btn
          >
        </div>
        <div class="pa-2">
          <v-btn class="info font-weight-bold" @click="onSortButton"
            ><v-icon left>mdi-sort-alphabetical-ascending</v-icon
            ><span class="d-none d-sm-flex">並び替え</span
            ><span class="d-sm-none">並替</span></v-btn
          >
        </div>
        <div class="pa-2">
          <v-btn class="info font-weight-bold" @click="onItemCopy"
            ><v-icon left>mdi-content-copy</v-icon
            ><span class="d-none d-sm-flex">媒体コピー</span
            ><span class="d-sm-none">COPY</span></v-btn
          >
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex justify-end">
          <synchro-cast-component
            @reset="reset"
            :key="comResetKey"
          ></synchro-cast-component>
        </div>
      </v-app-bar>
    </div>
    <div>
      <list-table-component :key="resetKey"></list-table-component>
    </div>
  </div>
</template>

<script>
import { ref, reactive, toRefs } from "@vue/composition-api";
import { useRouter } from "@/utils";
import SynchroCastComponent from "./synchroCast";
import ListTableComponent from "./listTable";
import store from "@/store/index.js";
import utilFunc from "@/common/utilFunc.js";

export default {
  components: {
    SynchroCastComponent,
    ListTableComponent,
  },
  setup(props, ctx) {
    const { router } = useRouter();
    const resetKey = ref(0);
    const comResetKey = ref(0);
    const fab = ref(0);

    const reset = () => {
      resetKey.value++;
      comResetKey.value++;
    };
    const state = reactive({
      rankingDeliMessageFlg: false,
    });

    const onNew = async () => {
      router.push({ name: "cast-edit", params: { cast_id: "new" } });
    };

    const onUpdateButton = async () => {
      router.push({ name: "cast-update" });
    };

    const onSortButton = async () => {
      router.push({ name: "cast-sort" });
    };

    const onItemCopy = async () => {
      router.push({ name: "cast-item-copy" });
    };

    const init = async () => {
      // 店舗チェック falseの場合ログアウトになる
      const currentShop = store.getters["shops/currentShop"];
      if (!(await utilFunc.checkShop(currentShop.id, router))) return;
    };

    init();

    return {
      ...toRefs(state),
      resetKey,
      comResetKey,
      reset,
      fab,
      onNew,
      onUpdateButton,
      onSortButton,
      onItemCopy,
    };
  },
};
</script>

<style scoped>
.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 48px;
  z-index: 100;
}
</style>
